import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 3000;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "james40_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  localStorage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export const publicApi = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
